// DASS-21 Extended Assessment (Part 2)
// 14 additional questions to complete the full DASS-21 clinical assessment
// These questions were not included in the initial mini-assessment

const dassQuestionsPart2 = {
  // ===== DEPRESSION (4 additional questions) =====
  depression: [
    {
      id: 'd4',
      question: "I found it difficult to work up the initiative to do things",
      dimension: 'depression',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'd5',
      question: "I was unable to become enthusiastic about anything",
      dimension: 'depression',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'd6',
      question: "I felt I wasn't worth much as a person",
      dimension: 'depression',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'd7',
      question: "I felt that life was meaningless",
      dimension: 'depression',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    }
  ],

  // ===== ANXIETY (5 additional questions) =====
  anxiety: [
    {
      id: 'a3',
      question: "I experienced breathing difficulty (e.g., excessively rapid breathing, breathlessness in the absence of physical exertion)",
      dimension: 'anxiety',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'a4',
      question: "I was worried about situations in which I might panic and make a fool of myself",
      dimension: 'anxiety',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'a5',
      question: "I felt I was close to panic",
      dimension: 'anxiety',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'a6',
      question: "I was aware of the action of my heart in the absence of physical exertion (e.g., sense of heart rate increase, heart missing a beat)",
      dimension: 'anxiety',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 'a7',
      question: "I felt scared without any good reason",
      dimension: 'anxiety',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    }
  ],

  // ===== STRESS (5 additional questions) =====
  stress: [
    {
      id: 's3',
      question: "I tended to over-react to situations",
      dimension: 'stress',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 's4',
      question: "I felt that I was using a lot of nervous energy",
      dimension: 'stress',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 's5',
      question: "I found myself getting agitated",
      dimension: 'stress',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 's6',
      question: "I was intolerant of anything that kept me from getting on with what I was doing",
      dimension: 'stress',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    },
    {
      id: 's7',
      question: "I felt that I was rather touchy",
      dimension: 'stress',
      answers: [
        { text: "Did not apply to me at all", score: 0 },
        { text: "Applied to me to some degree, or some of the time", score: 1 },
        { text: "Applied to me to a considerable degree, or a good part of time", score: 2 },
        { text: "Applied to me very much, or most of the time", score: 3 }
      ]
    }
  ]
};

// Helper function to get all Part 2 DASS questions in sequence
function getAllDASSQuestionsPart2() {
  return [
    ...dassQuestionsPart2.depression,
    ...dassQuestionsPart2.anxiety,
    ...dassQuestionsPart2.stress
  ];
}

// ES6 Exports
export { dassQuestionsPart2, getAllDASSQuestionsPart2 };
